webpackJsonp([7],{

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _CalculatorInput = __webpack_require__(85);

var _CalculatorInput2 = _interopRequireDefault(_CalculatorInput);

var _Responsive = __webpack_require__(25);

var _Utils = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RetirementCalculator = function (_React$Component) {
  _inherits(RetirementCalculator, _React$Component);

  _createClass(RetirementCalculator, null, [{
    key: 'init',
    value: function init(id, props) {
      _reactDom2.default.render(_react2.default.createElement(RetirementCalculator, props), document.getElementById(id));
    }
  }, {
    key: 'renderDetails',
    value: function renderDetails() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          'Retirement Calculator'
        ),
        _react2.default.createElement(
          'h4',
          null,
          'Methodology'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Our team at FormSwift created a retirement calculator to help you determine how much you will have saved and what your investment return will be. To use the calculator, insert the following inputs: current age, age of retirement, amount of money currently saved for retirement, annual retirement deposit, annual withdrawal amount from retirement savings (may or may not be applicable depending on age/situation), percent inflation, and percent investment return.'
        )
      );
    }
  }]);

  function RetirementCalculator() {
    _classCallCheck(this, RetirementCalculator);

    var _this = _possibleConstructorReturn(this, (RetirementCalculator.__proto__ || Object.getPrototypeOf(RetirementCalculator)).call(this));

    _this.state = {
      age: '',
      retirementAge: '',
      amountSaved: '',
      annualDeposit: '',
      inflationPercent: '3',
      investmentPercent: '6.5',
      retirementResult: '0',
      investmentResult: '0'
    };
    _this.calculateResults = _this.calculateResults.bind(_this);
    return _this;
  }

  _createClass(RetirementCalculator, [{
    key: 'calculateResults',
    value: function calculateResults() {
      var amountSaved = +this.state.amountSaved;
      var curAge = +this.state.age;
      var previousYearReturn = 0;
      var totalInvestmentReturn = 0;

      while (curAge <= +this.state.retirementAge) {
        amountSaved += previousYearReturn;
        var investmentReturn = amountSaved * (+this.state.investmentPercent / 100);
        var inflationDeduction = amountSaved * (+this.state.inflationPercent / 100);
        var investmentWithInflation = investmentReturn - inflationDeduction;
        previousYearReturn = investmentWithInflation + +this.state.annualDeposit;
        totalInvestmentReturn += investmentWithInflation;
        curAge += 1;
      }

      this.setState({
        retirementResult: (0, _Utils.formatNumber)(amountSaved.toFixed(2)),
        investmentResult: (0, _Utils.formatNumber)(totalInvestmentReturn.toFixed(2))
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'container retirement-calculator-container' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-md-2 col-md-offset-1' },
            _react2.default.createElement(
              _Responsive.LargeMobile,
              null,
              RetirementCalculator.renderDetails()
            ),
            _react2.default.createElement(_CalculatorInput2.default, {
              title: 'AGE',
              value: this.state.age,
              onChange: function onChange(age) {
                return _this2.setState({ age: age });
              }
            }),
            _react2.default.createElement(_CalculatorInput2.default, {
              title: 'RETIREMENT AGE',
              value: this.state.retirementAge,
              onChange: function onChange(retirementAge) {
                return _this2.setState({ retirementAge: retirementAge });
              }
            }),
            _react2.default.createElement('span', { className: 'divider' }),
            _react2.default.createElement(_CalculatorInput2.default, {
              title: 'AMOUNT CURRENTLY SAVED FOR RETIREMENT',
              value: this.state.amountSaved,
              onChange: function onChange(amountSaved) {
                return _this2.setState({ amountSaved: amountSaved });
              },
              type: 'monetary'
            }),
            _react2.default.createElement(_CalculatorInput2.default, {
              title: 'ANNUAL RETIREMENT DEPOSIT',
              value: this.state.annualDeposit,
              onChange: function onChange(annualDeposit) {
                return _this2.setState({ annualDeposit: annualDeposit });
              },
              type: 'monetary'
            }),
            _react2.default.createElement('span', { className: 'divider' }),
            _react2.default.createElement(_CalculatorInput2.default, {
              title: 'INFLATION (%)',
              value: this.state.inflationPercent,
              onChange: function onChange(inflationPercent) {
                return _this2.setState({ inflationPercent: inflationPercent });
              },
              type: 'percent'
            }),
            _react2.default.createElement(_CalculatorInput2.default, {
              title: 'INVESTMENT RETURN (%)',
              value: this.state.investmentPercent,
              onChange: function onChange(investmentPercent) {
                return _this2.setState({ investmentPercent: investmentPercent });
              },
              type: 'percent'
            }),
            _react2.default.createElement('span', { className: 'divider' }),
            _react2.default.createElement(
              'button',
              { onClick: this.calculateResults },
              ' Calculate '
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-md-7 col-md-offset-1' },
            _react2.default.createElement(
              _Responsive.Desktop,
              null,
              RetirementCalculator.renderDetails()
            ),
            _react2.default.createElement(
              'div',
              { className: 'retirement-calculator-results' },
              _react2.default.createElement(
                'p',
                null,
                'AMOUNT YOU WILL HAVE IN RETIREMENT'
              ),
              _react2.default.createElement(
                'span',
                null,
                this.state.retirementResult
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'retirement-calculator-results' },
              _react2.default.createElement(
                'p',
                null,
                'AMOUNT OF INVESTMENT RETURN'
              ),
              _react2.default.createElement(
                'span',
                null,
                this.state.investmentResult
              )
            ),
            _react2.default.createElement(
              'p',
              { className: 'retirement-calculator-link' },
              'Source: ',
              _react2.default.createElement(
                'a',
                { href: 'https://www.retirementsimulation.com/simple/' },
                'https://www.retirementsimulation.com/simple/'
              )
            )
          )
        )
      );
    }
  }]);

  return RetirementCalculator;
}(_react2.default.Component);

exports.default = RetirementCalculator;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RetirementCalculator = __webpack_require__(450);

var _RetirementCalculator2 = _interopRequireDefault(_RetirementCalculator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.RetirementCalculator = _RetirementCalculator2.default;

/***/ })

},[469]);


// WEBPACK FOOTER //
// seo-retirement-calculator.js